import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { getCookieConsent } from "@/utils/cookieConsent";

export const useGoogleAnalytics = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const location = useLocation();

  // Initialisation GA4 uniquement avec consentement
  useEffect(() => {
    const consent = getCookieConsent();
    const measurementId = "G-R06X5KHHPN";
    
    if (consent?.analytics && measurementId && !isInitialized) {
      ReactGA.initialize(measurementId, {
        gtagOptions: {
          anonymize_ip: true, // Anonymisation des IP pour RGPD
          send_page_view: false, // On gère manuellement les page views
        }
      });
      setIsInitialized(true);
      console.log("✅ Google Analytics initialisé avec consentement");
    }
  }, [isInitialized]);

  // Tracking automatique des pages
  useEffect(() => {
    if (isInitialized) {
      ReactGA.send({ 
        hitType: "pageview", 
        page: location.pathname + location.search 
      });
      console.log("📊 Page vue:", location.pathname);
    }
  }, [location, isInitialized]);

  // Méthode pour tracker un événement
  const trackEvent = useCallback((eventName: string, params?: Record<string, any>) => {
    if (isInitialized) {
      ReactGA.event(eventName, params);
      console.log("📊 Événement:", eventName, params);
    }
  }, [isInitialized]);

  // Méthode pour tracker une conversion
  const trackConversion = useCallback((conversionType: string, value?: number) => {
    if (isInitialized) {
      ReactGA.event("conversion", {
        conversion_type: conversionType,
        value: value,
        currency: "EUR"
      });
      console.log("💰 Conversion:", conversionType, value);
    }
  }, [isInitialized]);

  return {
    trackEvent,
    trackConversion,
    isInitialized
  };
};
